import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbda3116"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "blockui-overlay",
  role: "alertdialog",
  "aria-modal": "true"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingOverlayComponent',
  props: {
    lines: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "blockui-message",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line, i) => {
        return (_openBlock(), _createElementBlock("h1", {
          key: i,
          class: _normalizeClass({ sub: i === _ctx.lines.length - 1 })
        }, _toDisplayString(line), 3))
      }), 128))
    ])
  ]))
}
}

})